import React from 'react'

import LoadingIndicator from '@lyrahealth-inc/ui-core/lib/atoms/loadingIndicator/LoadingIndicator'
import { AlertIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/AlertIcon'
import { CheckSuccessIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/CheckSuccessIcon'
import { StopSignIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/StopSignIcon'
import { colors } from '@lyrahealth-inc/ui-core-crossplatform/src/styles/colors'

import { EligibilityMessageWithLinks } from './EligibilityMessageWithLinks'
import styles from './eligibilityResults.module.scss'

export const EligibilityResults: React.FC<EligibilityResultsProps> = ({ result, isLoading }) => {
  const eligibilityColors = {
    eligible: colors.green1,
    warning: colors.orange1,
    not_eligible: colors.red1,
    skipped_check: colors.orange1,
    lyra_code_customer: colors.ui_oatmeal3,
  }

  const eligibilityIcons = {
    eligible: <CheckSuccessIcon size={100} fillColor='#2b7e5b' backgroundColor='#b9d5c9' />,
    warning: <AlertIcon size={100} fillColor={colors.orange5} />,
    not_eligible: <StopSignIcon size={100} />,
    skipped_check: <AlertIcon size={100} fillColor={colors.orange5} />,
    lyra_code_customer: <AlertIcon size={100} fillColor={colors.orange5} />,
  }
  const status = (result.status || 'not_eligible') as keyof typeof eligibilityColors

  return isLoading ? (
    <div className={styles['loading-container']}>
      <LoadingIndicator size={45} />
    </div>
  ) : (
    <div
      className={styles['result-container']}
      style={{ backgroundColor: eligibilityColors[status] }}
      data-test-id='EligibilityResults-container'
    >
      <div className={styles['left-icon']}>{eligibilityIcons[status]}</div>
      <p className={styles['result-message']}>
        <EligibilityMessageWithLinks message={result.message || result.error} />
      </p>
      <div className={styles['right-icon']}></div>
    </div>
  )
}

type EligibilityResultsProps = {
  result: { status?: string; message?: string; error?: string }
  isLoading: boolean
}

export default EligibilityResults
